export enum FormsAccessPermissionsType {
    LoggedInUsersOnlyStudentRequired = 0,
    AllowAnonymousNoStudent = 1,
    AllowAnonymousStudentRequired = 2,
    LoggedInUsersOnlyNoStudent = 3
}